import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// material
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material";
import { ClubSelectRegisterComponent } from "./directives/club-select-register";

import { AppComponent } from "./app.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
import { NAV_DROPDOWN_DIRECTIVES } from "./shared/nav-dropdown.directive";

import { ChartsModule } from "ng2-charts/ng2-charts";
import { SIDEBAR_TOGGLE_DIRECTIVES } from "./shared/sidebar.directive";
import { AsideToggleDirective } from "./shared/aside.directive";
import { BreadcrumbsComponent } from "./shared/breadcrumb.component";

// Routing Module
import { AppRoutingModule } from "./app.routing";

// Layouts
import { FullLayoutComponent } from "./layouts/full-layout.component";
import { SimpleLayoutComponent } from "./layouts/simple-layout.component";
// Services
import { PaymentsService } from "./services/payments/payments.service";

import { ApiService } from "./services/api";
import { AuthGuardService } from "./services/auth-guard";
import { ElasticService } from "./services/elastic";
import { FormsService } from "./services/forms";
import { VersionCheckService } from "./services/check-version/version-check.service";

import { OAuthService } from "./services/o-auth";
import { PremiumGuardService } from "./services/premium-guard/premium-guard.service";

import { MessagingService } from "./services/messaging.service";
// Config
import { environment } from "./../environments/environment";
// External
import { AngularFireModule } from "angularfire2";
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import "firebase/storage";
import { PagerService } from "./services/pagination/pager.service";

import * as firebase from "firebase";

firebase.initializeApp(environment.firebase);
// import { DatabaseComponent } from './pages/database/database.component';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatCardModule,

    MatButtonModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [MatTabsModule, MatCardModule, MatButtonModule],
  declarations: [
    AppComponent,

    FullLayoutComponent,
    SimpleLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective
  ],
  providers: [
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy
    // },
    ApiService,
    AuthGuardService,
    ElasticService,
    FormsService,
    VersionCheckService,
    PaymentsService,
    PagerService,
    PremiumGuardService,
    OAuthService,
    MessagingService,
    AngularFireAuth,
    AngularFireDatabase
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/app.module.ts